import FBtn from './FNews.vue'

export default FBtn
